export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14841.4e550404.jpg";